export default "__VITE_ASSET__CQv18qyA__"